import { Container } from "react-bootstrap";

const helpImageUrl = (imageName: string) => `${process.env.PUBLIC_URL}/help/${imageName}`;

const HelpPage = () => {
    return (
        <Container className="p-1">
            <section>
                <h2 className="text-center">
                    Начало работы
                </h2>
                <p>
                    В данном разделе вы научитесь добавлять счета, клиентов и составлять с ними договора.
                </p>
                <h3 className="text-center">
                    Добавление рассчетного счета
                </h3>
                <p>
                    Для того, чтобы начать заключать договора с клиентами, вам необходимо добавить ваш рассчетны счет на странице счетов. 
                    Для начала в левой навигационной панеле выберите пункт "Счета", будет осуществлен переход на соответствующую страницу.
                </p>
                <img className="img-fluid img-thumbnail" src={helpImageUrl("1.png")} alt="Переход на страницу счетов" />
                <p className="mt-3">
                    В правом верхнем углу нажмите на кнопку "Добавить", появится окно добавления счета. Введите данные о счете и нажмите кнопку "Сохранить".
                </p>
                <img className="img-fluid img-thumbnail" src={helpImageUrl("2.png")} alt="Добавление счета" />
                <p className="mt-3">
                    При успешном добавлении счета элементы ввода станут недоступными. В правом верхнем углу окна нажмите на значок крестика, чтобы закрыть его.
                </p>
                <img className="img-fluid img-thumbnail" src={helpImageUrl("3.png")} alt="Закрытие окна просмотра счета" />
                <h3 className="text-center mt-2">
                    Добавление информации о клиенте
                </h3>
                <p>
                    В левой навигационной панеле выберите пункт "Клиенты", будет осуществлен переход на соответствующую страницу.
                </p>
                <img className="img-fluid img-thumbnail" src={helpImageUrl("4.png")} alt="Переход на страницу клиентов" />
                <p className="mt-3">
                    В правом верхнем углу нажмите на кнопку "Добавить", произодет переход на страницу добавления нового клиента.
                </p>
                <img className="img-fluid img-thumbnail" src={helpImageUrl("5.png")} alt="Переход на страницу добавления клиентов" />
                <p className="mt-3">
                    Введите данные о клиенте, после чего в правом верхнем углу нажмите кнопку "Сохранить". Произойдет переход на страницу пользователя.
                </p>
                <img className="img-fluid img-thumbnail" src={helpImageUrl("6.png")} alt="Ввод данных о клиенте" />
                <p className="mt-3">
                    Раскройте категорию "Счета клиента" при помощи нажатия на неё. В правом верхнем углу раскрывшегося пространства нажмите на кнопку "Добавить".
                    Откроется знакомое окно добавления счета, в котором необходимо заполнить данные о счете, после чего нажать кнопку "Сохранить".
                </p>
                <img className="img-fluid img-thumbnail" src={helpImageUrl("7.png")} alt="Добавление рассчетного счета клиента" />
                <p className="mt-3">
                    При успешном добавлении счета элементы ввода станут недоступными. В правом верхнем углу окна нажмите на значок крестика, чтобы закрыть его.
                </p>
                <img className="img-fluid img-thumbnail" src={helpImageUrl("8.png")} alt="Закрытие окна просмотра счета" />
                <h3 className="text-center mt-2">
                    Составление договора
                </h3>
                <p>
                    В левой навигационной панеле выберите пункт "Договора", будет осуществлен переход на соответствующую страницу.
                </p>
                <img className="img-fluid img-thumbnail" src={helpImageUrl("9.png")} alt="Переход на страницу договоров" />
                <p className="mt-3">
                    В правом верхнем углу страницы нажмите на кнопку "Составить договор", произодет переход на странцу составления договора.
                </p>
                <img className="img-fluid img-thumbnail" src={helpImageUrl("10.png")} alt="Переход на страницу составления договора" />
                <p className="mt-3">
                    Нажмите на выпадающий список рядом с надписью "Тип договора", затем выберите пункт "Продажа". После данного действия вы также увидите,
                    что произошла автоматическая подставновка вашего имени в категории "Счет продавца".
                </p>
                <img className="img-fluid img-thumbnail" src={helpImageUrl("11.png")} alt="Выбор типа договора" />
                <p className="mt-3">
                    Аналогично выпадающему списку с типами договоров выберите номер вашего счета, ФИО клиента и его счет. 
                    В правом верхнем углу категории "Товары" нажмите на кнопку "Добавить товар", откроется окно добавления товара.
                </p>
                <img className="img-fluid img-thumbnail" src={helpImageUrl("12.png")} alt="Выбор необходимых данных" />
                <p className="mt-3">
                    В списке товаров найдите необходимый, введите необходимое количество и нажмите значок плюса, чтобы добавить его к договору. 
                    После окончания работы с окном нажмите на крестик в правом верхнем углу окна добавления товаров.
                </p>
                <img className="img-fluid img-thumbnail" src={helpImageUrl("13.png")} alt="Добавление товара" />
                <p className="mt-3">
                    Проверьте данные и нажмите в правом верхнем углу страницы кнопку "Сохранить". Произойдет переход на страницу договора.
                </p>
                <img className="img-fluid img-thumbnail" src={helpImageUrl("14.png")} alt="Сохранение договора" />
                <p className="mt-3">
                    Договор успешно составлен. Теперь вы имеете базовые навыки для работы с системой!
                </p>
                <img className="img-fluid img-thumbnail" src={helpImageUrl("15.png")} alt="Страница договора" />
            </section>
        </Container>
    );
}

export default HelpPage;